// Donate section — legacy copy verbatim + Alipay QR. Split layout on
// desktop, stacked below 1024px.
export function Donate() {
  return (
    <section className="wv-h2-section wv-h2-section--light" id="donate">
      <div className="wv-h2-wrap">
        <h2>捐助</h2>
        <div className="wv-h2-section-rule"></div>
        <div className="wv-h2-donate-row">
          <div>
            <p>捐助完全是自愿的，免费玩家也可以享受完整的游戏内容与服务!</p>
            <p>
              我们每个月需要支付巨额服务器、备份服务和加速线路等开销。如果您是有一定经济能力的玩家，在不影响您生活的情况下，我们希望能获得您的支持。
            </p>
            <p>
              您只需要拥有支付宝帐号，就可以安全地向本服务器捐款，每一笔捐款都会有准确永久的记录(付款时请务必备注您的游戏账号，方便专人统计公布)。
            </p>
          </div>
          <img className="wv-h2-donate-qr" src="/static/images/index/donate-qr.jpg" alt="支付宝捐助二维码" loading="lazy" />
        </div>
      </div>
    </section>
  );
}
